<template>
    <van-action-sheet v-model="doctors.show" title="选择医生">
        <div class="doctors">
            <van-empty description="暂无可选医生" v-if="!doctors.list.length" />
            <div class="content">
                <div class="item" v-for="(item, index) in doctors.list" :key="index" @click="onDoctorChange(item)">
                    <div class="info">
                        <div class="avatar">
                            <van-image :src="item.photo" />
                        </div>
                        <div class="name">{{ item.staffName }}</div>
                    </div>
                    <div class="fee">
                        <span>{{ askMethodTypes.findValue({ value: doctors.askType }) }}</span>
                        <span>挂号费：</span>
                        <span>￥{{ onFeeGet(item) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </van-action-sheet>
</template>
<script>
import { askMethodTypes } from '@/hooks/useAsk'
import { AskMethodType } from '@/hooks/useAsk/type'
import api from "@/utils/request";

export default {
    name: "reservation-doctors",
    components: {},
    props: {

    },
    data() {
        return {
            askMethodTypes,
            doctors: {
                date: '',
                show: false,
                loading: false,
                list: [],
                askType: '',
                askServiceFee: '',
                doctorNo: ''
            }
        };
    },
    computed: {},
    mounted() { },
    destroyed() { },
    methods: {
        init(options = {}) {
            const { date, askType, askServiceFee, doctorNo } = options
            this.doctors.date = date
            this.doctors.askType = askType
            this.doctors.askServiceFee = askServiceFee
            this.doctors.doctorNo = doctorNo
            this.onDoctorGet()
            this.doctors.show = true
        },
        async onDoctorGet() {
            this.doctors.loading = true;
            try {
                const { data } = await api({
                    method: "get",
                    url: "/doctor-service/schedule/getWorkStaffByDate",
                    params: {
                        date: this.doctors.date,
                        // 1:医生，2:医助
                        type: 1,
                        // 1:小程序，2:线下门店 3:企业微信
                        source: 3
                    },
                });
                this.doctors.list = data.filter((row) => {
                    return this.doctors.askServiceFee === this.onFeeGet(row) && row.staffNo !== this.doctors.doctorNo
                });
            } catch (error) {

            }
            this.doctors.loading = false;
        },
        onFeeGet(row) {
            const askType = this.doctors.askType
            if (askType === AskMethodType.IMAGE) {
                return row.sketchAskPrice
            } else if (askType === AskMethodType.VIDEO) {
                return row.audioAskPrice
            } else if (askType === AskMethodType.STORE) {
                return row.clinicAskPrice
            } else if (askType === AskMethodType.PHONE) {
                return row.phoneAskPrice
            } else {
                return 0
            }
        },
        onDoctorChange(row) {
            this.$emit('change', row)
            this.doctors.show = false
        }
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

.van-action-sheet {
    max-height: 100%;
    height: 70vh;

    #{$deep} .van-action-sheet__header {
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }

    .content {
        .item {
            @include flex(center, space-between);
            gap: 10px;
            padding: 15px;
            border-bottom: 1px solid #eee;
            cursor: pointer;

            &:active {
                background: rgba(#f4f4f4, 0.5);
            }

            .info {
                @include flex(center);
                gap: 10px;

                .avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;
                }

                .name {
                    font-weight: bold;
                }
            }
        }
    }
}
</style>